const cleanLinesRe = /^\s*/gm;
const headersRe = /^(#+)(.*)/gim;
const imagesRe = /!\[([^[]+)\]\(([^)]+)\)/gim;
const linksRe = /\[([^[]+)\]\(([^)]+)\)/gim;
const boldRe = /(\*\*|__)(.*?)\1/gim;
const emphasisRe = /(\*|_)(.*?)\1/gim;
const delRe = /~~(.*?)~~/gim;
const quoteRe = /:"(.*?)":/gim;
const blockCodeRe = /```([^```]+)```/gim;
const inlineCodeRe = /`([^`]+)`/gim;
const ulListsRe = /\n\*+(.*)?/gim;
const olListsRe = /\n[0-9]+\.(.*)/gim;
const hrRe = /\n-{5,}/gim;
const blockQuoteRe = /\n(&gt;|>)(.*)/gim;
const paragraphsRe = /\n([^\n]+)\n/gim;
const paragraphsIgnoreRe = /^<\/?(ul|ol|li|h|p|bl|code|table|tr|td)/i;
const fixUlRe = /<\/ul>\s?<ul>/gim;
const fixOlRe = /<\/ol>\s?<ol>/gim;
const fixBlockQuoteRe = /<\/blockquote>\s?<blockquote>/gim;

const rules: any = {
  cleanLines: {
    regex: cleanLinesRe,
    replacer: (): string => "",
  },
  headers: {
    regex: headersRe,
    replacer: (match: any, $1: any, $2: any): string => {
      const h = $1.trim().length;
      return `<h${h}>${$2.trim()}</h${h}>`;
    },
  },
  images: {
    regex: imagesRe,
    replacer: (match: any, $1: any, $2: any): string => {
      return `<img src="${$2}" alt="${$1}">`;
    },
  },
  links: {
    regex: linksRe,
    replacer: (match: any, $1: any, $2: any): string => {
      // Since interactions are hosted under iframe, this ensure any anchor link wont replace but opens
      // a popup instead. This is customized behaviour and should be intended that way.
      // Its recommented to check event-stopPropagation to cancel any event bubbling during development.
      return `<a target="popup" onclick="window.open('${$2}'); return false;">${$1}</a>`;
    },
  },
  bold: {
    regex: boldRe,
    replacer: (match: any, $1: any, $2: any): string => {
      return `<strong>${$2}</strong>`;
    },
  },
  emphasis: {
    regex: emphasisRe,
    replacer: (match: any, $1: any, $2: any): string => {
      return `<em>${$2}</em>`;
    },
  },
  del: {
    regex: delRe,
    replacer: (match: any, $1: any, $2: any): string => {
      return `<del>${$1}</del>`;
    },
  },
  quote: {
    regex: quoteRe,
    replacer: (match: any, $1: any, $2: any): string => {
      return `<q>${$1}</q>`;
    },
  },
  blockCode: {
    regex: blockCodeRe,
    replacer: (match: any, $1: any, $2: any): string => {
      return `<pre><code>${$1}</code></pre>`;
    },
  },
  inlineCode: {
    regex: inlineCodeRe,
    replacer: (match: any, $1: any, $2: any): string => {
      return `<code>${$1}</code>`;
    },
  },
  ulLists: {
    regex: ulListsRe,
    replacer: (match: any, $1: any, $2: any): string => {
      return `<ul><li>${$1.trim()}</li></ul>`;
    },
  },
  olLists: {
    regex: olListsRe,
    replacer: (match: any, $1: any, $2: any): string => {
      return `<ol><li>${$1.trim()}</li></ol>`;
    },
  },
  hr: {
    regex: hrRe,
    replacer: (): string => {
      return "<hr />";
    },
  },
  blockQuote: {
    regex: blockQuoteRe,
    replacer: ($match: any, $1: any, $2: any): string => {
      return `\n<blockquote>${$2}</blockquote>`;
    },
  },
  paragraphs: {
    regex: paragraphsRe,
    replacer: ($match: any, $1: any): string => {
      const trimmed = $1.trim();
      if (paragraphsIgnoreRe.test(trimmed)) {
        return `\n${trimmed}\n`;
      }
      return `\n<p>${trimmed}</p>\n`;
    },
  },
  fixUl: {
    regex: fixUlRe,
    replacer: ($match: any, $1: any): string => "",
  },
  fixOl: {
    regex: fixOlRe,
    replacer: ($match: any, $1: any): string => "",
  },
  fixBlockquote: {
    regex: fixBlockQuoteRe,
    replacer: ($match: any, $1: any): string => "",
  },
};
/**
 * @param  {String} markdown A string of Markdown content
 * @returns {String} A HTML formatted string
 */
const Markdown = (markdown: string): string => {
  if (!markdown || markdown.length === 0) {
    return "";
  }
  Object.keys(rules).forEach((key: string) => {
    markdown = markdown.replace(rules[key].regex, rules[key].replacer);
  });
  return markdown.trim();
};

export default Markdown;
